import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

/** What the server's index holds; read again often while it is being filled */
export function useIndexStatus(serverId: string) {
  const api = useApiClient();
  return useQuery({
    queryKey: ['index', serverId], queryFn: () => api.index.status(serverId),
    refetchInterval: (q) => (q.state.data?.running ? 10_000 : 300_000),
  });
}

export function useFillIndex(serverId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.index.fill(serverId),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['index', serverId] }); },
  });
}
